import { AI_VERIFICATION_TYPES } from "@redotech/redo-return-core-common/return-flow";
import * as z from "zod";

export const classifyClaimImage = {
  name: "classifyClaimImage" as const,
  input: z.object({
    imageUrl: z.string(),
    verificationType: z.enum(AI_VERIFICATION_TYPES as [string, ...string[]]),
    itemDetails: z.string().optional(),
    itemImageUrl: z.string().optional(),
    strictness: z.number().optional(),
  }),
  output: z.object({
    category: z.string().nullable(),
    confidence: z.number().optional(),
    reason: z.string(),
  }),
};
